// extracted by mini-css-extract-plugin
module.exports = {"outer":"FlexPartners_outer__OtiIp"};